<template>
  <b-modal
    ref="update-price"
    id="update-price"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
  >
    <h4 class="purple mb-4">
      Atualizar valores do ciclo {{ selectedDate.cycle_name }}
    </h4>

    <b-row>
      <b-col md="4" class="mt-4">
        <b-form-group class="required">
          <label for="cycle">Ciclo</label>
          <multiselect
            id="cycle"
            :value="getCycleOption(selectedDate.cycle_id)"
            :options="cycles"
            :multiple="false"
            :allow-empty="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione"
            class="required"
            label="designation"
            track-by="id"
            selectLabel=""
            selectedLabel=""
            deselectLabel=""
            @select="setSelectedCycle"
          >
            <span slot="noResult">Nada encontrado</span>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col class="mt-4">
        <StandardInput
          v-model="selectedDate.cycle_name"
          type="text"
          name="Nome"
          label="Nome"
          :disabled="true"
        />
      </b-col>
      <b-col class="mt-4">
        <StandardInput
          v-model="selectedDate.cycle_description"
          type="text"
          name="Descricao"
          label="Descrição"
          :disabled="true"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col md="3" class="mt-4">
        <StandardInput
          v-model.number="selectedDate.sort_order"
          type="number"
          name="sort_order"
          label="Ordem de exibição"
          :min="1"
          placeholder="1"
        />
      </b-col>
      <b-col md="3" class="mt-4">
        <label>Valor da mensalidade</label>
        <CurrencyInput
          :value="selectedDate.instalment_price"
          @input="updateInstalmentPrice"
        />
      </b-col>
      <b-col md="3" class="mt-4">
        <label>Valor da anuidade</label>
        <CurrencyInput :value="selectedDate.annuity_price" :disabled="true" />
      </b-col>
      <b-col md="3" class="mt-4">
        <label>Taxa de material</label>
        <CurrencyInput v-model="selectedDate.material_fee" />
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col>
        <b-button class="btn large outline" @click="hideModal()">
          Voltar
        </b-button>
      </b-col>
      <b-col>
        <b-button
          id="del-btn"
          class="btn large blue"
          @click="deletePrice(selectedDate.id)"
        >
          Deletar
        </b-button>
      </b-col>
      <b-col class="text-right">
        <b-button class="btn large blue" @click="update(selectedDate.id)">
          Salvar
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import StandardInput from "@/components/inputs/StandardInput.vue";
import CurrencyInput from "@/components/inputs/CurrencyInput.vue";
import cyclesService from "@/services/cycles.service";
import httpRda from "../../http-rda";

export default {
  name: "UpdatePrice",
  components: {
    StandardInput,
    CurrencyInput,
  },
  props: {
    calendar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedDate: {},
      cycles: [],
    };
  },

  watch: {
    calendar() {
      if (this.calendar) {
        this.selectedDate = JSON.parse(JSON.stringify(this.calendar));
      }
    },
  },

  methods: {
    updateInstalmentPrice(value) {
      this.selectedDate.instalment_price = value;

      if (value && value > 0) {
        this.selectedDate.annuity_price = Math.round(value * 12);
      } else {
        this.selectedDate.annuity_price = 0;
      }
    },

    async deletePrice(priceId) {
      if (!priceId) {
        alert("Não foi possível deletar o preço");
        return;
      }
      if (confirm("Tem certeza que deseja deletar o preço?")) {
        await httpRda.delete(`/prices/${priceId}`);
        this.hideModal();
        window.location.reload();
      }
    },

    update(id) {
      const data = {
        id: this.selectedDate.id,
        cycle_id: Number(this.selectedDate.cycle_id),
        instalment_price: this.selectedDate.instalment_price,
        annuity_price: this.selectedDate.annuity_price,
        material_fee: this.selectedDate.material_fee || null,
        sort_order: this.selectedDate.sort_order,
      };

      if (!this.selectedDate.sort_order || this.selectedDate.sort_order < 1) {
        return this.$swal.fire({
          icon: "warning",
          title: "Campo inválido",
          text: "A ordem de exibição deve ser um número maior que zero.",
        });
      }

      if (!Number.isInteger(data.cycle_id) || data.cycle_id <= 0) {
        return this.$swal.fire({
          icon: "warning",
          title: "Campo obrigatório",
          text: "Selecione o ciclo do preço.",
        });
      }

      httpRda
        .patch(`/prices/${id}`, data)
        .then(() => {
          window.location.reload();
          const Toast = this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });
          Toast.fire({
            icon: "success",
            title: "Preço atualizado com sucesso!",
          });
          this.hideModal();
        })
        .catch((error) => {
          this.message =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possível atualizar!",
            footer: `${this.message.details}`,
          });
        });
    },

    hideModal() {
      this.$refs["update-price"].hide();
    },

    async getCycles() {
      const response = await cyclesService.index();
      this.cycles = response.data.cycles;
    },

    getCycleOption(cycleId) {
      return this.cycles.find((cycle) => Number(cycle.id) === Number(cycleId));
    },

    setSelectedCycle(cycle) {
      this.selectedDate.cycle_id = Number(cycle.id);
    },
  },

  created() {
    this.getCycles();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";

div#update-price {
  .modal-dialog {
    max-width: 820px;
    .modal-content {
      background-color: $grey2;
      border: 0;
      border-radius: 12px;
      .modal-body {
        padding: 40px;
      }
    }
  }

  h4.purple {
    color: $purple;
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 2px solid $grey5;
  }

  label {
    display: block;
    margin-bottom: 6px;
    font-weight: 600;
    color: #495057;
    font-size: 14px;
  }

  #del-btn {
    background-color: $purple;
    border-color: $purple;
    color: white;

    &:hover {
      background-color: white;
      border-color: $purple;
      color: $purple;
    }
  }
}
</style>
